import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className="relative h-screen bg-cover bg-center" style={{ backgroundImage: "url('/img/hero-bg.jpeg')" }}>
      <div className="absolute inset-0 bg-navy bg-opacity-60 flex items-center justify-center">
        <div className="text-center text-white px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-fade-in">Exo Contracting Inc.</h1>
          <p className="text-lg md:text-2xl mb-8 animate-fade-in delay-100">Premier Painting Solutions for Bridges, Water Towers, and Commercial Properties</p>
          <Link to="/contact" className="bg-gold text-navy px-6 py-3 rounded-full font-semibold hover:bg-yellow-500 transition-colors animate-fade-in delay-200">Get a Quote</Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;